import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import ServiceService from '../../../../Services/serviceService';
import OpportunityStatusEnum from '../../../../Enums/OpportunityStatusEnum';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import ErrorMessage from '../../../ErrorMessage';

export default class ServiceSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    if (this.props.selectValues && this.props.selectValues.length > 0) {
      this.setState({ itemList: this.props.selectValues });
      return;
    }
    this.populateListData();
  }

  componentDidUpdate(prevProps) {
    if (this.props.idFilter !== prevProps.idFilter) {
      this.populateListData();
    }
  }

  populateListData() {
    if (!this.props.idFilter) {
      this.setState({ selectValues: [] });
      return;
    }

    ServiceService.GetServiceListByClientId(this.props.idFilter)
      .then((result) => {
        if (!Array.isArray(result)) {
          this.setState({ selectValues: [] });
          ErrorMessage.SetErrorMessage('SES47');
          return;
        }
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result
          .sort((a, b) => (a.name > b.name ? 1 : -1))
          .forEach((serviceitem, index) => {
            if (!this.props.onlyActive || this.isStartedOpportunity(serviceitem)) {
              optValues.push({
                label: `${serviceitem.serviceId} - ${serviceitem.name}`,
                value: serviceitem.serviceId,
                disabled: false,
              });
            }
          });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('SES66');
      });
  }

  isStartedOpportunity(service) {
    const today = new Date(dateTimeHelper.toYYYYsMMsDD(new Date()));
    const endDate = new Date(
      dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(service.opportunityActualEndOn), 30))
    );
    return (
      new Date(service.opportunityActualStartOn) < today &&
      today < endDate &&
      service.opportunityStatusCode === OpportunityStatusEnum.OpportunityWon
    );
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
